<template>
  <div class="box">
    <img src="https://s6.bihukankan.com/img/1693389140Group 4814.png" alt="" class="img">
    <div class="box_brand">
      <div class="title_1">
        <span style="color: #ff5000;">十六项</span>定制化流量服务
      </div>
      <div class="title_2">
        让品牌实现高效曝光，声量与销量齐发
      </div>
      <div class="list" v-for="(item,index) in listData" :key="index">
          <div class="list_top">{{ item.title }}</div>
          <ul>
            <li v-for="(val,num) in item.list">
            <div class="index">{{ num + 1 }}</div>
            <span>{{ val }}</span>
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listData:[
        {title:'九大曝光服务',list:['壁虎看看官网首页曝光','壁虎看看小程序首页曝光','壁虎看看官网【品牌招商】页面','壁虎看看官网【品牌招商】页面','《直播电商内参》杂志万人分发','壁虎看看kol官网首页推荐曝光','视频露出，壁虎看看官方背书','壁虎看看百大社群，私域曝光','朋友圈群发、曝光服务']},
        {title:'七大定制服务',list:['定制品牌热销版面','壁虎看看「商品推荐」名单','量身打造API数据接口服务','品牌数据报告定制化服务','红人好货主播对接服务','成为壁虎看看合作主播优选供应商','品牌约稿、专访文章']}
      ]
    }
  },
  methods: {}
}
</script>

<style scoped lang="less">
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  .img {
    width: 100vw;
  }
  .box_brand {
    z-index: 1;
    position: relative;
    top: -55px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    border-radius: 24px 24px 0 0;
    width: 100vw;
    .title_1 {
      font-size: 16px;
      font-weight: 500;
      color: #252E39;
      margin: 24px 0;
      font-weight: 500;
    }
    .title_2 {
      font-size: 14px;
      font-weight: 500;
      color: #252E39;
      font-weight: 500;
    }
  }
  .list {
    border-radius: 4px;
    width: 351px;
    position: relative;
    margin-top: 40px;
    box-shadow: 0px 0px 8px 0px #A8B2C514;
    box-shadow: 0px 0px 24px 0px #00000014;
    padding: 38px 0 12px 24px;
    .list_top {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -14px;
      width: 150px;
      height: 28px;
      border-radius: 4px 4px 0 0;
      background: linear-gradient(44.87deg, #2A89F4 4.35%, #54BEFA 92.44%);
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 16px;
      color: #fff;
    }
    ul {
      li{
        display: flex;
        margin-bottom: 14px;
        .index {
          width: 16px;
          height: 16px;
          border-radius: 8px;
          font-size: 16px;
          color: #fff;
          background-color: #FF7A3A;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
        }
        span {
          font-size: 14px;
         color: #252E39;
        }
      }
    }
  }
}
</style>
